module.exports = __webpack_public_path__ + "img/iconfont.ad68bf74.svg";